import { render, staticRenderFns } from "./notificationsSending.vue?vue&type=template&id=196137ef&"
import script from "./notificationsSending.vue?vue&type=script&lang=js&"
export * from "./notificationsSending.vue?vue&type=script&lang=js&"
import style0 from "./notificationsSending.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports